 (function(){
    // ============================================================
    // DEBUG FLAGS — Toggle behavior while testing
    // ============================================================
    // Set all to `false` when going live in production.
    var DEBUG_MODE         = false;   // true = verbose logs in console
    var DISABLE_KLAVIYO    = false;  // true = skip Klaviyo (Salesforce-only test)
    var DISABLE_SALESFORCE = false;  // true = skip Salesforce submit (Klaviyo-only test)
    var DISABLE_REDIRECT   = false;   // true = do NOT redirect after Step 4 (stay on popup for debug)
    var DISABLE_POPUP_COOKIE = false;   // ← true = ignore cookie, popup always shows
    var POPUP_DELAY_MS       = 10000;      // ←  ms before popup appears (production: 10000)
    var DISABLE_CAPTCHA      = false;   // ←  true = bypass reCAPTCHA validation, enable buttons immediately
  
  
    // ============================================================
    // CONFIGURATION
    // ============================================================
    var SITE_KEY               = '6LfTzsYrAAAAACaR_VnHx5p0MyHKA43p1oJbOGuS'; // reCAPTCHA v2 site key
    var KLAVIYO_PUBLIC_KEY     = 'Usp634';                                   // Klaviyo Public API Key
    var KLAVIYO_EMAIL_LIST_ID  = 'W3xsGe';                                   // List for EMAIL subscribers
    var KLAVIYO_SMS_LIST_ID    = 'T5GJhT';                                   // List for SMS subscribers

    // ============================================================
    // ANTI-SPAM DATA
    // ============================================================
    var disposableEmailDomains = [
      'tempmail.com', 'guerrillamail.com', '10minutemail.com', 'throwaway.email',
      'mailinator.com', 'trashmail.com', 'getnada.com', 'temp-mail.org',
      'fakeinbox.com', 'yopmail.com', 'maildrop.cc', 'sharklasers.com',
      'guerrillamail.info', 'grr.la', 'guerrillamail.biz', 'guerrillamail.de',
      'spam4.me', 'mintemail.com', 'mytemp.email', 'mohmal.com', 'trtrtrt.com',
      'gay.email', 'vtext.com', 'tmomail.net'
    ];
  
    var legitimateDomains = [
      'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com',
      'aol.com', 'protonmail.com', 'mail.com', 'zoho.com', 'gmx.com',
      'live.com', 'msn.com', 'yandex.com', 'inbox.com', 'fastmail.com'
    ];
  
    var suspiciousPatterns = [
      /^test\d+@/i, /^spam/i, /^fake/i, /^\d{10,}@/, /^[a-z]{20,}@/i,
      /noreply/i, /no-reply/i
    ];
  
  
    // ============================================================
    // STATE
    // ============================================================
    // Tracks whether the user clicked "No thanks" (skip SMS) or "Activate" (full submit)
    var submittingFromNoThanks = false;
  
  
    // ============================================================
    // ANTI-SPAM VALIDATION FUNCTIONS
    // ============================================================
    function isDisposableEmail(email) {
      var domain = email.split('@')[1];
      if (!domain) return false;
      domain = domain.toLowerCase();
      return disposableEmailDomains.some(function (d) {
        return domain === d || domain.endsWith('.' + d);
      });
    }
  
    function hasExcessiveRepetition(str) {
      if (/(.)\1{2,}/.test(str)) return true;
      var patterns = str.match(/(.{2,4})\1{2,}/g);
      return patterns && patterns.length > 0;
    }
  
    function hasUnrealisticVowelRatio(str) {
      var vowels = str.match(/[aeiou]/gi);
      var consonants = str.match(/[bcdfghjklmnpqrstvwxyz]/gi);
      if (!vowels || !consonants) return false;
      var total = vowels.length + consonants.length;
      if (total < 4) return false;
      var ratio = vowels.length / total;
      return ratio < 0.15 || ratio > 0.70;
    }
  
    function hasKeyboardPattern(str) {
      var patterns = ['qwerty', 'asdf', 'zxcv', 'sds', '123', '456', '789', 'abc', 'xyz', 'sdsds'];
      var lower = str.toLowerCase();
      return patterns.some(function (p) { return lower.includes(p); });
    }
  
    function hasSuspiciousDomain(email) {
      var domain = email.split('@')[1];
      if (!domain) return false;
      var domainName = domain.split('.')[0];
      if (legitimateDomains.includes(domain.toLowerCase())) return false;
      if (hasExcessiveRepetition(domainName)) return true;
      if (hasUnrealisticVowelRatio(domainName)) return true;
      if (hasKeyboardPattern(domainName)) return true;
      if (domainName.length < 3) return true;
      return false;
    }
  
    function hasRandomLocalPart(email) {
      var localPart = email.split('@')[0];
      if (hasExcessiveRepetition(localPart)) return true;
      if (hasUnrealisticVowelRatio(localPart)) return true;
      if (hasKeyboardPattern(localPart)) return true;
      if (localPart.length >= 5) {
        var hasVowel = /[aeiou]/i.test(localPart);
        var hasConsonant = /[bcdfghjklmnpqrstvwxyz]/i.test(localPart);
        if (!hasVowel || !hasConsonant) return true;
      }
      return false;
    }
  
    function calculateEntropy(str) {
      var freq = {};
      var entropy = 0;
      for (var i = 0; i < str.length; i++) {
        var c = str[i].toLowerCase();
        freq[c] = (freq[c] || 0) + 1;
      }
      for (var c in freq) {
        var p = freq[c] / str.length;
        entropy -= p * Math.log2(p);
      }
      return entropy;
    }
  
    function hasHighEntropy(email) {
      var local = email.split('@')[0];
      var domain = email.split('@')[1];
      if (!domain) return false;
      var domainName = domain.split('.')[0];
      return calculateEntropy(local) > 4.5 || calculateEntropy(domainName) > 4.5;
    }
  
    function hasSuspiciousPattern(email) {
      return suspiciousPatterns.some(function (p) { return p.test(email); });
    }
  
    function isValidEmail(email) {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    }
  
    function checkEmailForSpam(email) {
      var issues = [];
      if (isDisposableEmail(email))    issues.push('Temporary email not allowed');
      if (hasSuspiciousPattern(email)) issues.push('Invalid email format');
      if (hasRandomLocalPart(email))   issues.push('Invalid email format');
      if (hasSuspiciousDomain(email))  issues.push('Invalid email domain');
      if (hasHighEntropy(email))       issues.push('Email appears randomly generated');
      return issues;
    }
  
  
    // ============================================================
    // PHONE NORMALIZATION (E.164 for Klaviyo SMS)
    // ============================================================
    // Klaviyo SMS requires phone in E.164 format: +[country code][number]
    // We assume US (+1) since this site serves US customers.
    // Accepts any format: "555-123-4567", "(555) 123.4567", "5551234567" — all become "+15551234567"
    function normalizePhoneToE164(rawPhone) {
      if (!rawPhone) return null;
  
      // Strip everything except digits
      var digitsOnly = rawPhone.replace(/\D/g, '');
  
      // US numbers should have 10 digits (area code + number)
      // If it has 11 and starts with 1, it already includes country code
      if (digitsOnly.length === 11 && digitsOnly.charAt(0) === '1') {
        return '+' + digitsOnly;
      }
      if (digitsOnly.length === 10) {
        return '+1' + digitsOnly;
      }
  
      // Anything else is invalid (too short or too long)
      return null;
    }


// ============================================================
  // KLAVIYO — EMAIL LIST SUBSCRIPTION
  // ============================================================
  // Subscribes the user to the Email list. Called on BOTH "Activate" and "No thanks".
  // Always includes the interest as a custom property for segmentation.
  function sendToKlaviyoEmail(email, interest, phoneE164) {
    var profileAttributes = {
      email: email,
      properties: {
        source: 'Shopify Popup',
        interest: interest || 'Unknown'
      }
    };
 
    // If phone is provided, also attach it as the official phone_number field
    // so future SMS consent flows can use it.
    if (phoneE164) {
      profileAttributes.phone_number = phoneE164;
    }
 
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_EMAIL_LIST_ID } }
        }
      }
    };
 
    if (DEBUG_MODE) {
      console.group('🟣 [KLAVIYO EMAIL] Sending subscription');
      console.log('Email:', email);
      console.log('Interest:', interest);
      console.log('Phone:', phoneE164 || '(none)');
      console.log('List ID:', KLAVIYO_EMAIL_LIST_ID);
      console.groupEnd();
    }
 
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (DEBUG_MODE) {
        console.log('🟣 [KLAVIYO EMAIL] Status:', res.status, res.ok ? '(OK)' : '(FAILED)');
      }
      if (!res.ok) throw new Error('Klaviyo Email returned ' + res.status);
      return res;
    });
  }
 
 
  // ============================================================
  // KLAVIYO — SMS LIST SUBSCRIPTION
  // ============================================================
  // Subscribes the user to the SMS list. Only called when phone is provided
  // AND user clicked "Activate" (not "No thanks").
  // Requires phone in E.164 format ("+1XXXXXXXXXX").
      function sendToKlaviyoSMS(email, interest, phoneE164) {
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Shopify Popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    phone_number: phoneE164,
                    properties: {
                      source: 'Shopify Popup',
                      interest: interest || 'Unknown'
                    }
                  }
                  // ← NO meta, NO subscriptions here
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: KLAVIYO_SMS_LIST_ID } }
            }
          }
        };

        if (DEBUG_MODE) {
          console.group('🟠 [KLAVIYO SMS] Sending subscription (simplified — no explicit consent)');
          console.log('Email:', email);
          console.log('Interest:', interest);
          console.log('Phone:', phoneE164);
          console.log('List ID:', KLAVIYO_SMS_LIST_ID);
          console.log('Full payload:', JSON.stringify(payload, null, 2));
          console.groupEnd();
        }

        return fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify(payload)
          }
        ).then(function (res) {
          if (DEBUG_MODE) {
            console.log('🟠 [KLAVIYO SMS] Status:', res.status, res.ok ? '(OK)' : '(FAILED)');
          }
          return res.text().then(function (text) {
            var body = null;
            try { body = text ? JSON.parse(text) : null; } catch (e) { body = text; }

            if (DEBUG_MODE) {
              console.group('🟠 [KLAVIYO SMS] Response body');
              console.log(body);
              if (!res.ok && body && body.errors) console.table(body.errors);
              console.groupEnd();
            }

            if (!res.ok) {
              var errorMsg = 'Klaviyo SMS ' + res.status;
              if (body && body.errors && body.errors.length > 0) {
                errorMsg += ': ' + body.errors.map(function (e) {
                  return (e.title || '') + ' — ' + (e.detail || '');
                }).join(' | ');
              }
              throw new Error(errorMsg);
            }
            return body;
          });
        });
      }
 
  // ============================================================
  // SALESFORCE — native form submit via hidden iframe
  // ============================================================
  // Salesforce Web-to-Lead form handlers don't support CORS for AJAX.
  // We use the existing pattern: native form.submit() into a hidden iframe,
  // so the browser doesn't navigate away and we can show Step 4 in the popup.
  function submitToSalesforce(formEl) {
    if (DEBUG_MODE) {
      console.group('🔵 [SALESFORCE] Triggering native form submit (via hidden iframe)');
      console.log('Form action:', formEl.action);
      console.log('Target (iframe):', formEl.target);
      console.log('Fields being submitted:');
      Array.prototype.forEach.call(formEl.elements, function (el) {
        if (el.name) {
          var val = el.value || '';
          console.log('  ' + el.name + ' =', val.length > 80 ? val.substring(0, 80) + '...' : val);
        }
      });
      console.groupEnd();
    }
    formEl.submit();
  }
 
 
  // ============================================================
  // UI HELPERS
  // ============================================================
  function goToStep(stepNumber) {
    // Hide all steps
    document.querySelectorAll('.adrnl-form__paso').forEach(function (el) {
      el.style.display = 'none';
    });
    // Show the target step
    var target = document.querySelector('.adrnl-form__paso--paso-' + stepNumber);
    if (target) target.style.display = 'block';
 
    // Update stepper indicator
    var steps = document.querySelectorAll('.stepper-item');
    steps.forEach(function (s) { s.classList.remove('stepper-item--active'); });
    if (steps[stepNumber - 1]) steps[stepNumber - 1].classList.add('stepper-item--active');
  }
 
  function showErrorOnStep3(message) {
    // Find or create an error message element inside step 3
    var step3 = document.querySelector('.adrnl-form__paso--paso-3');
    if (!step3) return;
    var errorEl = step3.querySelector('.popup-error-message');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'popup-error-message';
      errorEl.style.color = '#c00';
      errorEl.style.marginTop = '10px';
      step3.appendChild(errorEl);
    }
    errorEl.textContent = message;
  }
  // ============================================================
  // POPUP VISIBILITY (cookie-based)
  // ============================================================
  // The popup shows ONCE per visitor (30-day cookie).
  // During debug, DISABLE_POPUP_COOKIE=true forces it to show every time.

  function setPopupCookie() {
    if (DISABLE_POPUP_COOKIE) {
      if (DEBUG_MODE) console.log('🍪 [COOKIE] Skipped setting (DISABLE_POPUP_COOKIE=true)');
      return;
    }
    var expiry = new Date();
    expiry.setDate(expiry.getDate() + 30);
    document.cookie = 'adrnl_popup_hidden=true; path=/; expires=' + expiry.toUTCString();
    if (DEBUG_MODE) console.log('🍪 [COOKIE] Popup cookie set (expires in 30 days)');
  }

  function hasPopupCookie() {
    if (DISABLE_POPUP_COOKIE) {
      if (DEBUG_MODE) console.log('🍪 [COOKIE] Ignoring existing cookie (DISABLE_POPUP_COOKIE=true)');
      return false;
    }
    return document.cookie.split(';').some(function (item) {
      return item.trim().startsWith('adrnl_popup_hidden=');
    });
  }

 
  // ============================================================
  // MAIN FLOW — DOMContentLoaded
  // ============================================================
  document.addEventListener('DOMContentLoaded', function () {
    var form        = document.querySelector('form.adrnl-form');
    var emailInput  = document.getElementById('emailCustomer');
    var phoneInput  = document.getElementById('telephoneNumber');
    var realEmail   = document.getElementById('real-email');
    var realPhone   = document.getElementById('real-phone');
    var interestInput = document.getElementById('selectedInterest');
    var urlField    = document.getElementById('form-source-field');
    var popup = document.querySelector('.adrnl-popup');
    var closeBtn = document.querySelector('.adrnl-popup__close');

    // ====================================================
    // DEBUG: Si DISABLE_CAPTCHA está activo, habilita los botones
    // y oculta el widget del captcha del paso 3
    // ====================================================
  if (DISABLE_CAPTCHA) {
    var activateBtn = document.getElementById('endformularyPopup');
    var noThanksBtn = document.getElementById('no-thanks-button');
    if (activateBtn) activateBtn.disabled = false;
    if (noThanksBtn) noThanksBtn.disabled = false;
    
    var captchaEl = document.getElementById('captcha_element_popup');
    if (captchaEl) captchaEl.style.display = 'none';
    
    if (DEBUG_MODE) console.log('🚧 [DEBUG] Captcha disabled — buttons enabled, captcha hidden');
  }

      // --------------------------------------------------------
      // POPUP SHOW/HIDE LOGIC
      // --------------------------------------------------------
      if (popup) {
        if (hasPopupCookie()) {
          // Returning visitor who already saw the popup — keep hidden
          popup.style.display = 'none';
          if (DEBUG_MODE) console.log('🍪 [POPUP] Hidden (cookie exists)');
        } else {
          // First-time visitor (or debug mode) — show after delay
          setTimeout(function () {
            popup.style.display = 'flex'; //before 'block'
            setPopupCookie();
            if (DEBUG_MODE) console.log('👀 [POPUP] Shown (delay=' + POPUP_DELAY_MS + 'ms)');
          }, POPUP_DELAY_MS);
        }
      }

      // Close button — hide the popup
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          if (popup) popup.style.display = 'none';
          // Cookie already set when it opened, no need to set again
          if (DEBUG_MODE) console.log('✖️ [POPUP] Closed by user');
        });
      }

 
    if (urlField) urlField.value = window.location.href;
 
    // --------------------------------------------------------
    // STEP 1 → STEP 2: interest button click
    // --------------------------------------------------------
    var interestButtons = document.querySelectorAll('.adrnl-form__paso--paso-1 .button-adrnl');
    interestButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        // Save the button's visible text (e.g. "Player", "Parent", "Coach")
        // This goes to Salesforce field 00N4x00000Pf53B and Klaviyo "interest" property
        interestInput.value = button.value;
        if (DEBUG_MODE) console.log('👤 Interest selected:', button.value);
        goToStep(2);
      });
    });
 
    // --------------------------------------------------------
    // STEP 2 → STEP 3: email submit
    // --------------------------------------------------------
    var step2Button = document.querySelector('.adrnl-form__paso--paso-2 input[type="button"]');
    if (step2Button) {
      step2Button.addEventListener('click', function () {
        var email = emailInput.value.trim().toLowerCase();
        if (!email || !isValidEmail(email)) {
          alert('Please enter a valid email.');
          return;
        }
        realEmail.value = email;
        goToStep(3);
      });
    }
 
    // --------------------------------------------------------
    // Sync visible inputs → hidden inputs on every change
    // --------------------------------------------------------
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        realEmail.value = emailInput.value;
      });
    }
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        realPhone.value = phoneInput.value;
      });
    }
 
    // --------------------------------------------------------
    // "No thanks" button — skip SMS list
    // --------------------------------------------------------
    var noThanksBtn = document.getElementById('no-thanks-button');
    if (noThanksBtn) {
      noThanksBtn.addEventListener('click', function () {
        submittingFromNoThanks = true;
        realEmail.value = emailInput.value;
        // Phone is intentionally NOT copied — user opted out of SMS
        realPhone.value = '';
        if (DEBUG_MODE) console.log('🚫 "No thanks" clicked — SMS will be skipped');
      });
    }
 
    // --------------------------------------------------------
    // FORM SUBMIT HANDLER (both "Activate" and "No thanks")
    // --------------------------------------------------------
    form.addEventListener('submit', function (e) {
      e.preventDefault(); // We'll decide when to actually submit to Salesforce
 
      var email     = (realEmail.value || emailInput.value || '').trim().toLowerCase();
      var rawPhone  = submittingFromNoThanks ? '' : (phoneInput.value || '').trim();
      var interest  = interestInput.value || '';
 
      if (DEBUG_MODE) {
        console.group('📝 Popup form submit — preparing');
        console.log('Email:', email);
        console.log('Phone (raw):', rawPhone);
        console.log('Interest:', interest);
        console.log('Mode:', submittingFromNoThanks ? 'NO THANKS (email only)' : 'ACTIVATE (email + sms)');
        console.groupEnd();
      }
 
      // --- Validation 1: email present and valid ---
      if (!email || !isValidEmail(email)) {
        showErrorOnStep3('Please enter a valid email.');
        return;
      }
 
      // --- Validation 2: anti-spam on email ---
      var emailIssues = checkEmailForSpam(email);
      if (emailIssues.length > 0) {
        showErrorOnStep3('Please use a valid email address.');
        if (DEBUG_MODE) console.log('❌ SPAM BLOCKED:', emailIssues);
        return;
      }
 
      // --- Validation 3: phone (only if Activate — optional but must be valid if provided) ---
      var phoneE164 = null;
      if (!submittingFromNoThanks && rawPhone) {
        phoneE164 = normalizePhoneToE164(rawPhone);
        if (!phoneE164) {
          showErrorOnStep3('Please enter a valid US phone number (10 digits).');
          return;
        }
      }
 
      // Update hidden phone field with normalized value (for Salesforce)
      realPhone.value = phoneE164 || '';
 
      // --- Build the list of Klaviyo promises ---
      var klaviyoPromises = [];
 
      if (DISABLE_KLAVIYO) {
        if (DEBUG_MODE) console.log('⏸️ [KLAVIYO] All skipped (DISABLE_KLAVIYO=true)');
      } else {
        // ALWAYS send to Email list (regardless of Activate vs No thanks)
        klaviyoPromises.push(sendToKlaviyoEmail(email, interest, phoneE164));
 
        // Only send to SMS list if user clicked "Activate" AND provided a valid phone
        if (!submittingFromNoThanks && phoneE164) {
          klaviyoPromises.push(sendToKlaviyoSMS(email, interest, phoneE164));
        } else if (DEBUG_MODE) {
          console.log('⏸️ [KLAVIYO SMS] Skipped (' +
            (submittingFromNoThanks ? 'No thanks clicked' : 'no phone provided') + ')');
        }
      }
 
      // Disable submit buttons during request to prevent double-clicks
      var activateBtn = document.getElementById('endformularyPopup');
      if (activateBtn) activateBtn.disabled = true;
      if (noThanksBtn) noThanksBtn.disabled = true;
 
      // --- Fire Klaviyo in parallel, then Salesforce if all OK ---
      Promise.all(klaviyoPromises)
        .then(function () {
          if (DEBUG_MODE) console.log('✅ [KLAVIYO] All subscriptions OK — proceeding to Salesforce');
 
          if (DISABLE_SALESFORCE) {
            if (DEBUG_MODE) console.log('⏸️ [SALESFORCE] Skipped (DISABLE_SALESFORCE=true)');
            goToStep(4);
            return;
          }
 
          // Submit to Salesforce via hidden iframe (no page navigation)
          submitToSalesforce(form);
 
          // Show Step 4 after a brief delay so Salesforce has time to process
          setTimeout(function () {
            goToStep(4);
          }, 700);
        })
        .catch(function (err) {
          console.error('❌ [POPUP] Submission failed:', err);
          showErrorOnStep3('Something went wrong. Please try again.');
          if (activateBtn) activateBtn.disabled = false;
          if (noThanksBtn) noThanksBtn.disabled = false;
          // Reset submittingFromNoThanks so next attempt starts fresh
          submittingFromNoThanks = false;
        });
    });
  });
 
 
  // ============================================================
  // reCAPTCHA v2 CALLBACKS (unchanged from original)
  // ============================================================
  window.verifyCallbackPopup = function (response) {
    if (!response) return;
    document.getElementById('endformularyPopup').disabled = false;
    document.getElementById('no-thanks-button').disabled = false;
 
    var realEmail  = document.getElementById('real-email');
    var realPhone  = document.getElementById('real-phone');
    var emailInput = document.getElementById('emailCustomer');
    var phoneInput = document.getElementById('telephoneNumber');
 
    realEmail.value = (emailInput && emailInput.value) || '';
    realPhone.value = (phoneInput && phoneInput.value) || '';
 
    if (!realEmail.value) {
      alert('Please enter your email before submitting.');
      document.getElementById('endformularyPopup').disabled = true;
      document.getElementById('no-thanks-button').disabled = true;
    }
  };
 
  window.expiredCallbackPopup = function () {
    document.getElementById('endformularyPopup').disabled = true;
    document.getElementById('no-thanks-button').disabled = true;
  };
 
  window.errorCallbackPopup = function () {
    document.getElementById('endformularyPopup').disabled = true;
    document.getElementById('no-thanks-button').disabled = true;
    alert('reCAPTCHA error. Please try again.');
  };
 
  // Define the actual captcha render function
window._popupCaptchaReady = function () {
  // Skip rendering if captcha is disabled for debug
  if (DISABLE_CAPTCHA) {
    if (DEBUG_MODE) console.log('🚧 [DEBUG] Captcha render skipped (DISABLE_CAPTCHA=true)');
    return;
  }
  
  if (window.grecaptcha && typeof grecaptcha.render === 'function') {
    grecaptcha.render('captcha_element_popup', {
      'sitekey': SITE_KEY,
      'callback': window.verifyCallbackPopup,
      'expired-callback': window.expiredCallbackPopup,
      'error-callback': window.errorCallbackPopup,
      'theme': 'dark'
    });
  }
};

// If reCAPTCHA already called the callback while we were loading, run now
if (window._popupCaptchaPending) {
  window._popupCaptchaReady();
}
})();